import { t } from 'i18next';

import { EmergencyIcon } from 'assets/svg';
import {
  TeamingReason,
  TeamingType,
} from 'features/teaming/teaming-base/enums';
import theme from 'features/theme/theme';

/* Functions use in this case because 't' function from 'i18next' works only with this solution */
export const getTeamingBaseReasonOptions = () => ({
  languageComprehension: {
    text: t('teamingReason.languageComprehension'),
    value: TeamingReason.SpokenLanguage,
  },
  unfamiliarContent: {
    text: t('teamingReason.unfamiliarContent'),
    value: TeamingReason.SpecializedContent,
  },
  conferenceCall: {
    text: t('teamingReason.conferenceCall'),
    value: TeamingReason.ConferenceCall,
  },
  emergency: {
    text: t('teamingReason.emergency'),
    value: TeamingReason.Emergency,
    customIcon: <EmergencyIcon />,
    customColor: theme.palette.emergency.text,
  },
});

export const getTeamingRemoteLocationOptions = () => ({
  remoteAnyVi: {
    text: t('teamRequest.remoteAnyVi'),
    value: TeamingType.RemoteRq,
    isDefault: true,
  },
  remoteInCenterVi: {
    text: t('teamRequest.remoteInCenterVi'),
    value: TeamingType.RemoteIc,
  },
});

export const getTeamingInCenterLocationOptions = () => ({
  inCenterAnyVi: {
    text: t('teamRequest.inCenterAnyVi'),
    value: TeamingType.Request,
  },
  inCenterPreferredVi: {
    text: t('teamRequest.inCenterPreferredVi'),
    value: TeamingType.AdhocReq,
  },
});

export const getTeamingReasonText = (reason: TeamingReason) => {
  const teamingReasonsTranslateMap: Partial<Record<TeamingReason, string>> = {
    [TeamingReason.Asl]: 'teamingReason.languageComprehension',
    [TeamingReason.SpecializedContent]: 'teamingReason.unfamiliarContent',
    [TeamingReason.ConferenceCall]: 'teamingReason.conferenceCall',
    [TeamingReason.Emergency]: 'teamingReason.emergency',
    [TeamingReason.SpokenLanguage]: 'teamingReason.languageComprehension',
  };
  const reasonKey = teamingReasonsTranslateMap[reason];

  return reasonKey ? t(reasonKey) : '';
};
